import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import cookie from 'js-cookie'
import request from 'lib/request'

export default function ImpersonationBanner ({ impersonation }) {
  const [session, setSession] = useState(impersonation)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const [loginUrl, setLoginUrl] = useState(null)

  useEffect(() => {
    let mounted = true
    // Works even if the selected user's main profile request fails or is denied.
    request('api/user/impersonate/status').then(response => {
      if (mounted) setSession(response.impersonation)
    }).catch(() => {
      if (mounted) setSession(impersonation)
    })
    return () => { mounted = false }
  }, [impersonation])

  const stop = async () => {
    if (busy) return
    setBusy(true)
    setError('')
    try {
      const response = await request('api/user/impersonate/stop', 'POST', {
        headers: { 'X-CSRFToken': cookie.get('csrftoken') }
      })
      if (response.success) {
        window.location.assign(response.redirect_url)
        return
      }
      setError(response.error_message || 'Không thể trở về admin.')
      setLoginUrl(response.redirect_url || null)
    } catch (err) {
      setError('Không thể trở về admin. Hãy tải lại trang và thử lại.')
    }
    setBusy(false)
  }

  if (!session || !session.active) return null

  return (
    <div className='alert alert-warning mb-0' role='status'>
      <span>Đang impersonate: <strong>{session.target_email}</strong>. </span>
      <span>Thao tác được thực hiện với quyền của tài khoản này. </span>
      {loginUrl
        ? <a href={loginUrl}>Đăng nhập lại admin</a>
        : (
          <button type='button' className='btn btn-sm btn-warning' disabled={busy} onClick={stop}>
            {busy ? 'Đang trở về…' : 'Trở về admin'}
          </button>
        )}
      {error && <div role='alert'>{error}</div>}
    </div>
  )
}

ImpersonationBanner.propTypes = {
  impersonation: PropTypes.shape({
    active: PropTypes.bool,
    target_email: PropTypes.string
  })
}
